import styled from 'styled-components';

export const StyledContactWrapper = styled.div`
background: url(../img/contact.jpg) no-repeat center center / cover;
min-height: 40vh;
color: white;
text-align: center;

.fa-envelope , .fa-phone  {
font-size: 3rem;
}

.center-container {
display: flex;
justify-content: center;
align-items: center;
padding: 70px 20px;

@media only screen and (max-width: 550px) {
flex-direction: column;
}
}

.contact-grid-left{
padding-right: 30px;
border-right: 1px solid gray;

@media only screen and (max-width: 550px) {
padding-right: 0;
border: 0;
border-bottom: 1px solid gray;
padding-bottom: 20px;
}
 .grid-left-item {
 display: flex;
 align-items: center;
 padding: 10px 0;
 color: white;
 transition: 0.2s all ease-in;
 
 &.mail {
     &:hover {
     color: #69a5ff;
     }
 }
 
  &.phone {
     &:hover {
     color: #3ab42c;
     }
  }
 }
}

.contact-grid-right {
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
padding-left: 30px;
@media only screen and (max-width: 550px) {
padding-left: 0;
padding-top: 20px;
}
}
`;
